import { useState } from 'react';
import { AlertCircle } from 'lucide-react';
import Card, { CardHeader, CardBody } from './ui/Card';
import { initiateZoomLogin } from './ZoomAuth';
import { initiateGoogleLogin } from './GoogleAuth';
import { initiateMicrosoftLogin } from './MicrosoftAuth';
import './PasscodeAuth-revised.css';

const PasscodeAuthRevised = ({ initialError = '' }) => {
    const [error, setError] = useState(initialError);

    const handleProviderClick = (initiateFn) => {
        setError('');
        initiateFn();
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-brand">
                    <div className="auth-logo">
                        <img src="/assets/qolsync-logo-animated.svg" alt="QolSync AI Logo" className="logo-img" />
                    </div>
                    <h1 className="qolsync-brand-text"><span className="brand-qol">Qol</span><span className="brand-sync">Sync</span><span className="brand-ai">AI</span></h1>
                </div>

                <Card glass className="auth-card">
                    <CardHeader className="text-center">
                        <h2>Welcome</h2>
                        <p>Sign in to continue</p>
                    </CardHeader>

                    <CardBody>
                        {error && (
                            <div className="auth-error-message">
                                <AlertCircle size={18} />
                                <span>{error}</span>
                            </div>
                        )}

                        <div className="auth-providers">
                            {/* Zoom */}
                            <button
                                className="auth-provider-btn auth-provider-zoom"
                                onClick={() => handleProviderClick(initiateZoomLogin)}
                            >
                                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M4.585 10.432a2.09 2.09 0 0 0-2.09 2.09v4.888a2.09 2.09 0 0 0 2.09 2.091h7.418a2.09 2.09 0 0 0 2.091-2.09v-1.632l4.003 2.668a.872.872 0 0 0 1.35-.728V9.282a.872.872 0 0 0-1.35-.728l-4.003 2.668v-1.632a2.09 2.09 0 0 0-2.09-2.09H4.584z"/>
                                </svg>
                                <span>Sign in with Zoom</span>
                            </button>

                            {/* Google */}
                            <button
                                className="auth-provider-btn auth-provider-google"
                                onClick={() => handleProviderClick(initiateGoogleLogin)}
                            >
                                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24">
                                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                                </svg>
                                <span>Sign in with Google</span>
                            </button>

                            {/* Microsoft */}
                            <button
                                className="auth-provider-btn auth-provider-microsoft"
                                onClick={() => handleProviderClick(initiateMicrosoftLogin)}
                            >
                                <svg aria-hidden="true" width="20" height="20" viewBox="0 0 23 23" fill="none">
                                    <path d="M0 0H10.9324V10.9324H0V0Z" fill="#F25022" />
                                    <path d="M11.7588 0H22.6912V10.9324H11.7588V0Z" fill="#7FBA00" />
                                    <path d="M0 11.7589H10.9324V22.6912H0V11.7589Z" fill="#00A4EF" />
                                    <path d="M11.7588 11.7589H22.6912V22.6912H11.7588V11.7589Z" fill="#FFB900" />
                                </svg>
                                <span>Sign in with Microsoft</span>
                            </button>
                        </div>

                        <div className="auth-info">
                            <p>New users receive a free trial with 10 minutes of translation per day.</p>
                        </div>
                    </CardBody>
                </Card>

                <p className="auth-footer">
                    &copy; {new Date().getFullYear()} QolSync AI. All rights reserved.
                </p>
            </div>
        </div>
    );
};

export default PasscodeAuthRevised;
